import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: '首页', public: true, fullscreen: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { title: '登录', public: true, fullscreen: true },
  },
  {
    path: '/apps',
    name: 'AppMarket',
    component: () => import('@/views/AppMarketView.vue'),
    meta: { title: '应用市场', public: true },
  },
  {
    path: '/workspace',
    name: 'Workspace',
    component: () => import('@/views/WorkspaceView.vue'),
    meta: { title: '工作台' },
  },
  {
    path: '/billing',
    name: 'Billing',
    component: () => import('@/views/BillingView.vue'),
    meta: { title: '计费中心' },
  },
  {
    path: '/billing/recharge',
    name: 'Recharge',
    component: () => import('@/views/RechargeView.vue'),
    meta: { title: '充值' },
  },
  {
    path: '/api-keys',
    name: 'ApiKeys',
    component: () => import('@/views/ApiKeyView.vue'),
    meta: { title: 'API Key 管理' },
  },
  {
    path: '/redeem',
    name: 'Redeem',
    component: () => import('@/views/RedeemView.vue'),
    meta: { title: '兑换码' },
  },
  {
    path: '/developer',
    name: 'Developer',
    component: () => import('@/views/DeveloperView.vue'),
    meta: { title: '开发者平台' },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { title: '个人中心' },
  },
  {
    path: '/orgs',
    name: 'OrgManage',
    component: () => import('@/views/OrgManageView.vue'),
    meta: { title: '组织管理' },
  },
  {
    path: '/orgs/:orgId/members',
    name: 'MemberManage',
    component: () => import('@/views/MemberManageView.vue'),
    meta: { title: '成员管理' },
  },
  {
    path: '/apps/:code',
    name: 'AppDetail',
    component: () => import('@/views/AppDetailView.vue'),
    meta: { title: '应用详情', public: true },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: { title: '找回密码', public: true, fullscreen: true },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('@/views/NotificationsView.vue'),
    meta: { title: '消息通知' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 阿旺应用中心` : '阿旺应用中心'

  const userStore = useUserStore()
  const isPublic = to.meta.public === true

  if (!isPublic && !userStore.isLoggedIn) {
    next('/login')
    return
  }

  if (to.path === '/login' && userStore.isLoggedIn) {
    next('/workspace')
    return
  }

  next()
})

export default router
